import { useState } from "react";
import { Link } from "react-router-dom";
import PlusMinusInput from "components/Form/PlusMinusInput/PlusMinusInput";
import DeleteDialog from "components/Dialogs/DeleteDielog";
import useAPI from "hooks/useAPI";
import { currencyFormat } from "../../helpers/functions";
import { useTranslation } from "react-i18next";
import styles from "./CartDialog.module.scss";

const CartDrawerItem = ({ item, onNavigate, translateKey }) => {
    const { t } = useTranslation();
    const api = useAPI();
    const [loading, setLoading] = useState(false);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const product = item?.product;
    const productId = product?.basic_data?.id_product ?? product?.id;
    const currency = product?.price?.currency;
    const rebate = product?.price?.per_item?.rebate;
    const discount = product?.price?.per_item?.discount;
    const rebateNames = rebate?.rebates?.map((entry) => entry?.calc?.calc_name).filter(Boolean).join(", ");
    const priceLabel = (key) => `${t(`${translateKey}-table_th-${key}`).replace(/:\s*$/, "")}:`;

    const setQuantity = (quantity) => {
        api.globalAddToCart(productId, quantity, loading, setLoading, undefined, undefined, "", "replace");
    };

    return (
        <article className={styles.item} aria-busy={loading}>
            <div className={styles.itemHeader}>
                <div className={styles.itemIdentity}>
                    <Link to={`/katalog/artikal/${product?.id}`} onClick={onNavigate} className={styles.productName}>{product?.basic_data?.name}</Link>
                    {product?.basic_data?.attributes_text && <span className={styles.attributes}>{product.basic_data.attributes_text}</span>}
                    <span className={styles.sku}>{t(`${translateKey}-table_th-code`)}: {product?.basic_data?.sku}</span>
                </div>
                <button type="button" className={styles.removeButton} onClick={() => setShowDeleteDialog(true)} aria-label={`Izbriši ${product?.basic_data?.name}`} title="Izbriši">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M4.5 7h15M9.5 7V4.5h5V7M6.5 7l.7 12a1.5 1.5 0 0 0 1.5 1.4h6.6a1.5 1.5 0 0 0 1.5-1.4l.7-12M10 10.5v6M14 10.5v6" />
                    </svg>
                </button>
            </div>

            <div className={styles.itemPrices}>
                <div><span>{priceLabel("base_price")}</span><span>{currencyFormat(product?.price?.per_item?.price_with_out_vat, currency)}</span></div>
                <div><span>{priceLabel("rebate")}</span><span>{rebate?.active && rebateNames ? rebateNames : "0"}</span></div>
                <div><span>{priceLabel("discount")}</span><span>{discount?.active && Number(discount.amount) > 0 ? `-${currencyFormat(discount.amount, currency)}` : "0"}</span></div>
                <div><span>{priceLabel("price_excluding_vat")}</span><span>{currencyFormat(product?.price?.per_item?.price_subtotal, currency)}</span></div>
            </div>

            <div className={styles.itemFooter}>
                <div className={styles.itemControls}>
                    <div className={styles.quantity}>
                        <label className={styles.visuallyHidden} htmlFor={`${product?.id}_CartDrawer`}>{t(`${translateKey}-table_th-quantity`)}</label>
                        <PlusMinusInput
                            behaviours={product?.behaviours?.cart}
                            max={Number(product?.inventory?.amount)}
                            quantity={Number(item?.cart?.quantity ?? 0)}
                            setQuantity={setQuantity}
                            debounceId={`${product?.id}_CartDrawer`}
                            className={styles.quantityInput}
                        />
                    </div>
                </div>
                <div className={styles.lineTotal}>
                    <span>{priceLabel("total_excluding_vat")}</span>
                    <strong>{currencyFormat(product?.price?.cost?.subtotal, currency)}</strong>
                </div>
            </div>

            <DeleteDialog
                title={`${translateKey}-delete_dialog-title`}
                description={`${translateKey}-delete_dialog-description`}
                openDeleteDialog={{ show: showDeleteDialog }}
                setOpenDeleteDialog={() => setShowDeleteDialog(false)}
                handleConfirm={() => {
                    setQuantity(0);
                    setShowDeleteDialog(false);
                }}
            />
        </article>
    );
};

export default CartDrawerItem;
